import '../_rollupPluginBabelHelpers-1f0bf8c2.js';
import 'reakit-system/createComponent';
import 'reakit-system/createHook';
import 'reakit-utils/shallowEqual';
import '../Role/Role.js';
export { VisuallyHidden, useVisuallyHidden } from './VisuallyHidden.js';
